<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M16.0748 9.9998C16.0748 13.355 13.355 16.0748 9.9998 16.0748C6.64468 16.0748 3.9248 13.355 3.9248 9.9998C3.9248 6.64468 6.64468 3.9248 9.9998 3.9248C13.355 3.9248 16.0748 6.64468 16.0748 9.9998Z"
    :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="square"/>
    <path d="M16.0748 10H3.9248" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="square"/>
    <path d="M10.0002 16.0748C8.69542 16.0748 7.6377 13.355 7.6377 9.9998C7.6377 6.64468 8.69542 3.9248 10.0002 3.9248C11.305 3.9248 12.3627 6.64468 12.3627 9.9998C12.3627 13.355 11.305 16.0748 10.0002 16.0748Z"
    :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="square"/>
  </svg>
</template>

<script>
export default {
  name: 'MonthlyTrafficIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped></style>
